<template>
  <div class="home">
    <div class="container-fluid p-0">
      
      <div class="row g-2">
        <!-- Left Column: Job Selection and Equipment Tabs -->
        <div class="col-md-7 order-2 order-md-1" id="job-selection">
          <div class="card mb-2">
            <div class="card-body py-2">
              <!-- On mobile the class table is tall and rarely changed after the
                   first pick, so it collapses to give the item list room. The
                   toggle is a plain button on mobile and absent on desktop. -->
              <button class="class-toggle d-md-none" @click="classOpen = !classOpen"
                      :aria-expanded="classOpen ? 'true' : 'false'">
                <span><i class="fas fa-user"></i> Selecione uma Classe</span>
                <i class="fas" :class="classOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
              </button>
              <h5 class="card-title d-none d-md-block">Selecione uma Classe</h5>
              <div :class="{ 'd-none d-md-block': !classOpen }">
                <JobList />
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-body py-2">
              <!-- Server Filter Toggle -->
              <div class="d-flex justify-content-between align-items-center mb-2">
                <h5 class="card-title mb-0">Equipamentos</h5>
                <div class="server-filter-container" v-if="hasAvailabilityData">
                  <div class="form-check form-switch d-flex align-items-center">
                    <input class="form-check-input me-2" type="checkbox" id="serverFilterToggle" v-model="latamServerOnly">
                    <label class="form-check-label me-1" for="serverFilterToggle">Itens disponíveis no LatamRO</label>
                    <div v-if="isLoadingServerItems" class="spinner-border spinner-border-sm ms-1" role="status">
                      <span class="visually-hidden">Carregando...</span>
                    </div>
                  </div>
                </div>
              </div>

              <ul class="nav nav-tabs" id="equipmentTabs" role="tablist">
                <li class="nav-item" role="presentation">
                  <button class="nav-link active" id="head-top-tab" data-bs-toggle="tab" data-bs-target="#head-top" type="button" role="tab" aria-controls="head-top" aria-selected="true">Topo</button>
                </li>
                <li class="nav-item" role="presentation">
                  <button class="nav-link" id="head-mid-tab" data-bs-toggle="tab" data-bs-target="#head-mid" type="button" role="tab" aria-controls="head-mid" aria-selected="false">Meio</button>
                </li>
                <li class="nav-item" role="presentation">
                  <button class="nav-link" id="head-bottom-tab" data-bs-toggle="tab" data-bs-target="#head-bottom" type="button" role="tab" aria-controls="head-bottom" aria-selected="false">Baixo</button>
                </li>
                <li class="nav-item" role="presentation">
                  <button class="nav-link" id="garment-tab" data-bs-toggle="tab" data-bs-target="#garment" type="button" role="tab" aria-controls="garment" aria-selected="false">Capa</button>
                </li>
              </ul>

              <div class="tab-content" id="equipmentTabsContent">
                <div class="tab-pane fade show active" id="head-top" role="tabpanel" aria-labelledby="head-top-tab">
                  <div class="input-group my-2">
                    <input type="text" class="form-control" placeholder="Filtrar itens..." v-model="searchQuery">
                  </div>
                  <p class="selected-item-line"><span class="sil-slot">Topo</span><span class="sil-sep"> &ndash; </span><span class="sil-name" v-if="$store.state.headgear_top_item.name">{{ $store.state.headgear_top_item.name }}</span><span class="sil-none" v-else>nenhum item</span></p>
                  <div class="items-container">
                    <ItemListHeadTop :item_filter="searchQuery" />
                  </div>
                </div>
                <div class="tab-pane fade" id="head-mid" role="tabpanel" aria-labelledby="head-mid-tab">
                  <div class="input-group my-2">
                    <input type="text" class="form-control" placeholder="Filtrar itens..." v-model="searchQuery">
                  </div>
                  <p class="selected-item-line"><span class="sil-slot">Meio</span><span class="sil-sep"> &ndash; </span><span class="sil-name" v-if="$store.state.headgear_mid_item.name">{{ $store.state.headgear_mid_item.name }}</span><span class="sil-none" v-else>nenhum item</span></p>
                  <div class="items-container">
                    <ItemListHeadMid :item_filter="searchQuery" />
                  </div>
                </div>
                <div class="tab-pane fade" id="head-bottom" role="tabpanel" aria-labelledby="head-bottom-tab">
                  <div class="input-group my-2">
                    <input type="text" class="form-control" placeholder="Filtrar itens..." v-model="searchQuery">
                  </div>
                  <p class="selected-item-line"><span class="sil-slot">Baixo</span><span class="sil-sep"> &ndash; </span><span class="sil-name" v-if="$store.state.headgear_bottom_item.name">{{ $store.state.headgear_bottom_item.name }}</span><span class="sil-none" v-else>nenhum item</span></p>
                  <div class="items-container">
                    <ItemListHeadBottom :item_filter="searchQuery" />
                  </div>
                </div>
                <div class="tab-pane fade" id="garment" role="tabpanel" aria-labelledby="garment-tab">
                  <div class="input-group my-2">
                    <input type="text" class="form-control" placeholder="Filtrar itens..." v-model="searchQuery">
                  </div>
                  <p class="selected-item-line"><span class="sil-slot">Capa</span><span class="sil-sep"> &ndash; </span><span class="sil-name" v-if="$store.state.garment_item.name">{{ $store.state.garment_item.name }}</span><span class="sil-none" v-else>nenhum item</span></p>
                  <div class="items-container">
                    <ItemListGarment :item_filter="searchQuery" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Right Column: Character Preview and Controls -->
        <div class="col-md-5 order-1 order-md-2" id="character-preview">
          <div class="card">
            <div class="card-header py-1">
              <h5 class="card-title mb-0">Preview do Personagem</h5>
            </div>
            <div class="card-body py-2">
              <!-- Gender Selection - Above Character -->
              <div class="gender-controls mb-2">
                <div class="d-flex justify-content-center">
                  <GenderList />
                </div>
                <div class="d-flex justify-content-center gap-1 mt-2">
                  <button class="btn btn-outline-secondary btn-sm" @click="randomizeCharacter" title="Gerar personagem aleatório">
                    <i class="fas fa-dice"></i> Aleatório
                  </button>
                  <EquippedPanel />
                </div>
              </div>

              <!-- Character Preview with flanking turn buttons -->
              <div class="character-row mb-2">
                <div class="turn-col">
                  <button class="btn btn-sm btn-outline-secondary turn-btn" @click="SAVE_CHARACTER_HEAD('left')" title="Girar cabeça para a esquerda">
                    <i class="fas fa-arrow-left"></i> Cabeça
                  </button>
                  <button class="btn btn-sm btn-outline-secondary turn-btn" @click="SAVE_CHARACTER_POSITION('left')" title="Girar corpo para a esquerda">
                    <i class="fas fa-arrow-left"></i> Corpo
                  </button>
                </div>
                <div class="character-container text-center">
                  <Character ref="characterComponent" />
                </div>
                <div class="turn-col">
                  <button class="btn btn-sm btn-outline-secondary turn-btn" @click="SAVE_CHARACTER_HEAD('right')" title="Girar cabeça para a direita">
                    Cabeça <i class="fas fa-arrow-right"></i>
                  </button>
                  <button class="btn btn-sm btn-outline-secondary turn-btn" @click="SAVE_CHARACTER_POSITION('right')" title="Girar corpo para a direita">
                    Corpo <i class="fas fa-arrow-right"></i>
                  </button>
                </div>
              </div>

              <!-- Hair Style -->
              <div class="hair-style-section mb-2">
                <h6 class="text-center mb-1">Estilo de Cabelo</h6>
                <div class="hair-style-container hair-strip">
                  <HeadList />
                </div>
              </div>

              <!-- Hair Color -->
              <div class="hair-color-section mb-2">
                <h6 class="text-center mb-1">Cor do Cabelo</h6>
                <div class="d-flex justify-content-center flex-wrap hair-color-strip">
                  <HairColorList />
                </div>
              </div>

              <!-- Extras: body palette chips on top, toggles underneath -->
              <button class="class-toggle d-md-none mb-2" @click="extrasOpen = !extrasOpen"
                      :aria-expanded="extrasOpen ? 'true' : 'false'">
                <span><i class="fas fa-sliders"></i> Mais opções</span>
                <i class="fas" :class="extrasOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
              </button>
              <div class="extras-row mb-2" :class="{ 'd-none d-md-flex': !extrasOpen }">
                <div class="extras-group justify-content-center">
                  <small class="extras-label">Cor da Roupa</small>
                  <BodyPallete />
                </div>
                <div class="extras-toggles">
                  <CashMountCheckbox />
                  <OutfitCheckbox />
                </div>
              </div>

              <!-- Action Buttons: Reset / Random on the left, Download / Save on the right -->
              <div class="action-buttons d-flex justify-content-center align-items-center flex-wrap gap-1">
                <div class="d-flex gap-1">
                  <button class="btn btn-danger btn-sm" @click="RESET_CHARACTER" title="Voltar ao personagem padrão">
                    <i class="fas fa-trash"></i> Resetar
                  </button>
                  <button class="btn btn-outline-primary btn-sm" @click="shareCharacter" :title="shareCopiedFlash ? 'Link copiado!' : 'Compartilhar este personagem'">
                    <i class="fas fa-link"></i>
                    {{ shareCopiedFlash ? 'Copiado!' : 'Compartilhar' }}
                  </button>
                  <button class="btn btn-primary btn-sm" @click="downloadCharacterSprite">
                    <i class="fas fa-download"></i> Baixar PNG
                  </button>
                  <button class="btn btn-success btn-sm" @click="saveToProfile">
                    <i class="fas fa-save"></i> Salvar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import environment from "@/env";
import { mapState, mapMutations, mapGetters } from 'vuex'
import { eventBus } from "@/services/eventBus";
import { hasAvailabilityData } from "@/services/divinePrideService";
import { buildRandomCharacter } from "@/services/randomCharacter";
import { encodeShareCode, decodeShareCode } from "@/services/shareEncoding";
import GenderList from '../components/character/GenderList.vue'
import JobList from '../components/character/JobList.vue'
import HeadList from "@/components/character/HeadList.vue";
import HairColorList from "@/components/character/HairColorList.vue";
import ItemListHeadTop from "@/components/character/ItemListHeadTop.vue";
import ItemListHeadMid from "@/components/character/ItemListHeadMid.vue";
import ItemListHeadBottom from "@/components/character/ItemListHeadBottom.vue";
import ItemListGarment from "@/components/character/ItemListGarmet.vue";
import EquippedPanel from "@/components/character/EquippedPanel.vue";
import BodyPallete from "@/components/character/BodyPallete.vue";
import ClearCharacterButton from "@/components/character/ClearCharacterButton.vue";
import CashMountCheckbox from "@/components/character/CashMountCheckbox.vue";
import OutfitCheckbox from "@/components/character/OutfitCheckbox.vue";
import Character from "@/components/character/Character.vue";

// Dev-only logger — silent in production builds
const devLog = (...args) => {
  if (process.env.NODE_ENV !== "production") {
    console.log(...args);
  }
};

export default {
  name: "HomeView",
  components: {
    GenderList,
    HairColorList,
    HeadList,
    BodyPallete,
    JobList,
    ItemListHeadTop,
    ItemListHeadMid,
    ItemListHeadBottom,
    ItemListGarment,
    EquippedPanel,
    Character,
    ClearCharacterButton,
    CashMountCheckbox,
    OutfitCheckbox,
  },
  data() {
    return {
      searchQuery: "",
      // Mobile-only: whether the class picker is expanded (see .class-toggle).
      classOpen: false,
      // Mobile-only: 'Mais opções' (cor da roupa, montaria, roupa alternativa).
      extrasOpen: false,
      latamServerOnly: true, // Default to filtering for Latam server
      // The LatamRO filter only means something once latamAvailability.json is
      // populated; while it's empty the toggle would filter nothing, so we hide it
      // rather than assert something untrue to the player.
      hasAvailabilityData: hasAvailabilityData(),
      isLoadingServerItems: false, // Loading state for server filtering
      shareCopiedFlash: false, // Flips true for 1.5s after clipboard write acks
    };
  },
  computed: {
    ...mapGetters(['getServerFilter']),
  },
  watch: {
    latamServerOnly(newValue) {
      // Single place the filter changes (the template no longer also calls a
      // handler, which used to set it twice per toggle).
      this.SET_SERVER_FILTER(newValue ? 'LATAM' : 'all');
      eventBus.emit('refresh-filtered-items');
    }
  },
  created() {
    devLog('Vue app created, setting up message listener');
    window.addEventListener('message', this.handleParentMessage);
    
    // Listen for server items loading state changes
    eventBus.on('server-items-loading', (isLoading) => {
      this.isLoadingServerItems = isLoading;
    });
    
  },
  
  mounted() {
    devLog('Vue app mounted, sending VUE_APP_READY message to parent');

    // Priority order for initial character state:
    //   1. ?c=<code> share URL (overrides everything — user clicked a share link)
    //   2. localStorage (previous session)
    //   3. Defaults (RESET_CHARACTER)
    // A subsequent LOAD_CHARACTER_DATA postMessage from the React parent can
    // still override whichever of the above won, which is what we want when
    // the user is logged in and loading a saved profile build.
    const loadedFromShare = this.loadFromShareUrl();
    if (!loadedFromShare) {
      this.loadLocalStorage();
    }

    // Send ready message to parent (React app) to complete handshake
    window.parent.postMessage({
      type: 'VUE_APP_READY'
    }, '*');
  },
  
  beforeUnmount() {
    // Remove event listeners when component is unmounted
    window.removeEventListener('message', this.handleParentMessage);
    // We don't need to remove the keydown listener since it was added with an anonymous function
  },
  methods: {
    ...mapMutations([
      "SAVE_CHARACTER",
      "RESET_CHARACTER",
      "SAVE_CHARACTER_HEAD",
      "SAVE_CHARACTER_POSITION",
      "SET_SERVER_FILTER",
      "SAVE_HEADGEAR_TOP_ITEM",
      "SAVE_HEADGEAR_MID_ITEM",
      "SAVE_HEADGEAR_BOTTOM_ITEM",
      "SAVE_GARMENT_ITEM",
    ]),
    randomizeCharacter: function () {
      const rolled = buildRandomCharacter({
        itemDb: this.$store.state.ui.jsonFile,
        serverFilter: this.getServerFilter,
      });
      this.applyDecodedCharacter(rolled);
    },
    /**
     * Shared helper used by both randomize and share-URL loading. Commits
     * item metadata first so the headgear_*_item slots are hydrated by the
     * time the character watcher fires and the sprite re-renders.
     */
    applyDecodedCharacter: function (payload) {
      this.SAVE_HEADGEAR_TOP_ITEM(payload.topItem || {});
      this.SAVE_HEADGEAR_MID_ITEM(payload.midItem || {});
      this.SAVE_HEADGEAR_BOTTOM_ITEM(payload.bottomItem || {});
      this.SAVE_GARMENT_ITEM(payload.garmentItem || {});
      this.SAVE_CHARACTER(payload.character);
    },
    /**
     * Reads the `?c=<code>` query param from the iframe's own URL. The React
     * parent is responsible for forwarding it into the iframe src.
     * @returns {boolean} true if a valid share code was loaded
     */
    loadFromShareUrl: function () {
      try {
        const params = new URLSearchParams(window.location.search);
        const code = params.get('c');
        if (!code) return false;
        const decoded = decodeShareCode(code, this.$store.state.ui.jsonFile);
        if (!decoded) {
          devLog('Ignoring invalid share code:', code);
          return false;
        }
        this.applyDecodedCharacter(decoded);
        return true;
      } catch (err) {
        console.error('Error loading from share URL:', err);
        return false;
      }
    },
    /**
     * User clicked Compartilhar. Two paths:
     *  - Embedded (inside meurag iframe): let the React parent handle URL
     *    rewriting + clipboard + toast by posting SHARE_CHARACTER.
     *  - Standalone (visualrag.vercel.app opened directly): we do it
     *    ourselves. Share URLs always point at meurag.com regardless of
     *    where the user currently is — that's the canonical viewer.
     */
    shareCharacter: async function () {
      let code;
      try {
        code = encodeShareCode(this.$store.state);
      } catch (err) {
        console.error('Error building share code:', err);
        return;
      }

      const isEmbedded = window.parent !== window;
      if (isEmbedded) {
        // Embedded — React owns URL/clipboard/toast. It will post SHARE_COPIED
        // back which triggers the "Copiado!" button flash.
        window.parent.postMessage({ type: 'SHARE_CHARACTER', code }, '*');
        return;
      }

      // Standalone — build a meurag.com URL and copy it ourselves.
      const shareUrl = `https://www.meurag.com/simulador-visual?c=${encodeURIComponent(code)}`;
      try {
        await navigator.clipboard.writeText(shareUrl);
        this.shareCopiedFlash = true;
        setTimeout(() => { this.shareCopiedFlash = false; }, 1500);
      } catch (err) {
        console.error('Clipboard write failed:', err);
        // Last-ditch fallback: drop the URL into a prompt so the user can
        // copy manually. Ugly but survives every browser/permission mix.
        // eslint-disable-next-line no-alert
        window.prompt('Copie o link abaixo:', shareUrl);
      }
    },
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    },
    loadLocalStorage: function () {
      let character = localStorage.getItem("character");

      if (character != null) {
        this.SAVE_CHARACTER(JSON.parse(character));
      } else {
        this.RESET_CHARACTER();
      }
    },
    saveToProfile: function () {
      // Get the current character data from the store
      const characterData = {
        gender: this.$store.state.character.gender,
        job: this.$store.state.character.job[0],
        head: this.$store.state.character.head,
        headPalette: this.$store.state.character.headPalette,
        headdir: this.$store.state.character.headdir,
        // Convert headgear array to simple values to avoid cloning issues
        headgear: [...this.$store.state.character.headgear], // Create a shallow copy
        garment: this.$store.state.character.garment,
        bodyPalette: this.$store.state.character.bodyPalette,
        action: this.$store.state.character.action,
        outfit: this.$store.state.character.outfit,
        // Simplify headgearItems to avoid complex objects that can't be cloned
        headgearItems: {
          top: {
            id: this.$store.state.headgear_top_item.id || 0,
            name: this.$store.state.headgear_top_item.name || ''
          },
          mid: {
            id: this.$store.state.headgear_mid_item.id || 0,
            name: this.$store.state.headgear_mid_item.name || ''
          },
          bottom: {
            id: this.$store.state.headgear_bottom_item.id || 0,
            name: this.$store.state.headgear_bottom_item.name || ''
          },
          garment: {
            id: this.$store.state.garment_item.id || 0,
            name: this.$store.state.garment_item.name || ''
          }
        }
      };
      
      // We'll let the React app handle the subscription check
      // since it has access to the user's subscription data
      // The React component will enforce the save limits (3 for basic, unlimited for premium)
      
      // Send message to parent window (React app)
      try {
        window.parent.postMessage({
          type: 'SAVE_CHARACTER_TO_PROFILE',
          characterData: characterData
        }, '*');
        
        // Let the React app handle the success notification with toast
        // No alert here - React will show toast notifications
      } catch (error) {
        console.error('Error sending character data:', error);
        // Let the React app handle error notifications
        // No alert here - React will show toast notifications
      }
    },
    
    /**
     * Download the current character sprite as PNG.
     *
     * The actual PNG is produced by Character.getCharacterImageDataUrl(),
     * which already stamps "gerado no meurag.com" onto the canvas — that
     * watermark is applied here regardless of whether the user is on
     * meurag.com or the standalone visualrag.vercel.app, so the branding
     * is consistent.
     *
     * Two paths:
     *  - Embedded (inside meurag iframe): postMessage the React parent so
     *    it can trigger the download + toast with its own UX.
     *  - Standalone (visualrag.vercel.app opened directly): trigger the
     *    download ourselves via an <a download> link.
     */
    downloadCharacterSprite: function () {
      const characterComponent = this.$refs.characterComponent;
      if (!characterComponent) {
        console.error('Character component reference not found');
        return;
      }

      const imageDataUrl = characterComponent.getCharacterImageDataUrl();
      if (!imageDataUrl) {
        console.error('Failed to get character image data URL');
        return;
      }

      const jobName = this.$store.state.character.job[0] || 'character';
      const isEmbedded = window.parent !== window;

      if (isEmbedded) {
        try {
          window.parent.postMessage({
            type: 'DOWNLOAD_CHARACTER_SPRITE',
            imageData: imageDataUrl,
            characterName: jobName,
          }, '*');
        } catch (error) {
          console.error('Error sending sprite data for download:', error);
        }
        return;
      }

      // Standalone — trigger the browser download directly.
      try {
        const safeName = String(jobName).replace(/[^a-z0-9]/gi, '_').toLowerCase() || 'character';
        const filename = `meurag_${safeName}_${Date.now()}.png`;
        const link = document.createElement('a');
        link.href = imageDataUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error('Error triggering standalone download:', error);
      }
    },
    
    handleParentMessage: function (event) {
  // Validate event data exists and is an object
  if (!event.data || typeof event.data !== 'object') {
    return;
  }
  
  // Only process messages from the parent frame (React app)
  const allowedOrigins = ["https://meurag.com", "https://www.meurag.com", "http://localhost:3000"];
  if (event.origin !== 'null' && !allowedOrigins.includes(event.origin)) {
    // Browser/wallet extensions postMessage constantly; keep this dev-only so
    // it doesn't spam the production console.
    devLog('Ignoring message from unexpected origin:', event.origin);
    return; // Ignore messages from unexpected origins
  }
  
  // Ignore messages from React DevTools and other sources
  if (event.data.source === 'react-devtools-content-script' || 
      event.data.source === 'react-devtools-bridge' || 
      event.data.source === 'react-devtools-backend-manager') {
    return;
  }
  
  devLog('Message received from parent:', event.data);
  
  try {
    // React ack of a SHARE_CHARACTER postMessage — flash "Copiado!" on the button
    if (event.data.type === 'SHARE_COPIED') {
      this.shareCopiedFlash = true;
      setTimeout(() => { this.shareCopiedFlash = false; }, 1500);
      return;
    }

    // React could not copy (e.g. clipboard permission denied). Silent for now —
    // the parent owns user-facing notifications.
    if (event.data.type === 'SHARE_ERROR') {
      devLog('Share failed on parent side:', event.data.error);
      return;
    }

    // Handle handshake request from React
    if (event.data.type === 'HANDSHAKE_REQUEST') {
      devLog('Received handshake request from React, responding with VUE_APP_READY');
      
      // Send VUE_APP_READY message immediately
      window.parent.postMessage({ type: 'VUE_APP_READY' }, '*');
      
      // Send it again after a short delay to ensure it's received
      // This helps in case the first message is missed due to timing issues
      setTimeout(() => {
        devLog('Sending follow-up VUE_APP_READY message');
        window.parent.postMessage({ type: 'VUE_APP_READY' }, '*');
      }, 500);
      
      return; // Exit after handling handshake
    }
    
    // Handle character data loading
    if (event.data.type === 'LOAD_CHARACTER_DATA') {
      devLog('Processing LOAD_CHARACTER_DATA message');
      const characterData = event.data.characterData;
      
      if (!characterData) {
        console.error('Character data is missing in the message');
        return;
      }
      
      devLog('Character data received:', characterData);
      
      // Acknowledge receipt of character data
      window.parent.postMessage({ 
        type: 'CHARACTER_DATA_RECEIVED',
        timestamp: new Date().getTime()
      }, '*');
      
      const character = {
        gender: characterData.gender,
        job: [characterData.job],
        head: characterData.head,
        headPalette: characterData.headPalette,
        headdir: characterData.headdir || 0,
        bodydir: characterData.bodydir || 0,
        headgear: characterData.headgear || [],
        garment: characterData.garment || 0,
        bodyPalette: characterData.bodyPalette || 0,
        action: characterData.action || 0,
        outfit: characterData.outfit || 0
      };
      
      devLog('Saving character to store:', character);
      this.SAVE_CHARACTER(character);
      
      if (characterData.headgearItems) {
        devLog('Processing headgear items');
        if (characterData.headgearItems.top) {
          this.$store.commit('SAVE_HEADGEAR_TOP_ITEM', characterData.headgearItems.top);
        }
        if (characterData.headgearItems.mid) {
          this.$store.commit('SAVE_HEADGEAR_MID_ITEM', characterData.headgearItems.mid);
        }
        if (characterData.headgearItems.bottom) {
          this.$store.commit('SAVE_HEADGEAR_BOTTOM_ITEM', characterData.headgearItems.bottom);
        }
        if (characterData.headgearItems.garment) {
          this.$store.commit('SAVE_GARMENT_ITEM', characterData.headgearItems.garment);
        }
      }
      
      devLog('Character data successfully loaded into store');
      
      // Notify parent that character data was successfully processed
      window.parent.postMessage({ 
        type: 'CHARACTER_DATA_PROCESSED',
        success: true,
        timestamp: new Date().getTime()
      }, '*');
    }
  } catch (error) {
    console.error('Error processing message from parent:', error);
    
    // Notify parent of error
    window.parent.postMessage({ 
      type: 'VUE_APP_ERROR',
      error: error.message,
      timestamp: new Date().getTime()
    }, '*');
  }
},
    
  },
};
</script>

<style scoped>
.home {
  max-height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
}

.container-fluid {
  max-height: 100vh;
  padding: 0;
  overflow-y: auto;
}

.class-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 8px;
  padding: 6px 8px;
  background: #f4f6f8;
  border: 1px solid #e6e9ec;
  border-radius: 4px;
  font-size: 0.9rem;
  color: #212529;
}

.selected-item-line {
  margin: 0 0 4px;
  padding: 4px 8px;
  background: #f4f6f8;
  border: 1px solid #e6e9ec;
  border-radius: 4px;
  font-size: 0.8rem;
  line-height: 1.25;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sil-slot {
  font-weight: 600;
  color: #6c757d;
}
.sil-name {
  color: #212529;
}
.sil-none {
  color: #adb5bd;
  font-style: italic;
}

.items-container {
  height: 250px;
  overflow-y: auto;
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 5px;
  /* Always show the track so it's obvious this list scrolls on its own —
     an invisible overlay scrollbar reads as "the list just ends here". */
  scrollbar-width: thin;
}
.items-container::-webkit-scrollbar {
  width: 8px;
}
.items-container::-webkit-scrollbar-thumb {
  background: #c7ccd1;
  border-radius: 4px;
}
.items-container::-webkit-scrollbar-track {
  background: #f1f3f5;
  border-radius: 4px;
}

.card {
  margin-bottom: 0.5rem;
}

.card-body {
  padding: 0.5rem;
}

.item-list {
  padding: 5px;
}

.bg-gradient-ragnarok {
  background-image: linear-gradient(
    135deg,
    rgba(231, 231, 255, 1) 0%,
    rgba(255, 231, 231, 1) 35%,
    rgba(225, 255, 254, 1) 100%
  );
  padding: 5px;
}

.bg-gradient-ragnarok-border {
  border: solid 1px #dddddd;
  border-radius: 5px;
}

.ragnarok-card {
  padding: 5px;
}

.card-job-shadow {
  -webkit-box-shadow: 0px 0px 2px 5px #cddefb;
  box-shadow: 0px 0px 2px 5px #cddefb;
}

.card-job-inner {
  border: 1px dashed #4bb1f5;
  border-radius: 6px;
}

.character-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.turn-col {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex-shrink: 0;
}

.turn-btn {
  white-space: nowrap;
  min-width: 82px;
}

.character-container {
  height: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
}

.hair-style-container, .hair-color-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  max-height: 320px;
  overflow-y: auto;
  padding: 6px 4px;
}


.extras-row {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 6px 4px;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
}

.extras-group {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.extras-toggles {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  flex-wrap: wrap;
}

.extras-label {
  color: #6b7280;
  font-size: 0.78rem;
  white-space: nowrap;
}

.btn-tab-item {
  position: relative;
  width: 130px;
  min-height: 75px;
  border: 1px solid #d8d8d8 !important;
  margin-bottom: 3px;
  margin-left: 5px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  padding-left: 25px;
  padding-right: 5px;
}

.btn-tab-item img {
  width: 25px;
}

.btn-tab-item p {
  margin: 0;
  font-size: 12px;
  line-height: 1;
  text-align: right;
  width: 100%;
}

.btn-tab-item span {
  position: absolute;
  left: 0;
  top: 0px;
  height: 100%;
  width: 20px;
  background: #e8e8e8;
  color: #5b5b5b;
  border-radius: 5px 0 0 5px;
  font-size: 12px;
  line-height: 20px;
  text-transform: uppercase;
  writing-mode: vertical-lr;
  transform: rotate(-180deg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out;
}

.btn-tab-item.active span {
  color: #fff;
  background: var(--bs-nav-pills-link-active-bg);
}

.helper {
  padding: 5px;
  text-align: center;
  font-size: 12px;
  color: #999;
}

/* Make buttons smaller */
.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
}

/* Reduce spacing */
.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 0.75rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

/* Make headings smaller */
h6 {
  font-size: 0.9rem;
  margin-bottom: 0.25rem;
}

/* Server filter styling */
.server-filter-container {
  display: flex;
  align-items: center;
  background-color: #f8f9fa;
  border-radius: 4px;
  padding: 0.25rem 0.5rem;
  border: 1px solid #dee2e6;
}

.form-check-input.me-2 {
  margin-right: 0.5rem !important;
}

.form-check-label.me-1 {
  margin-right: 0.25rem !important;
  font-size: 0.85rem;
  white-space: nowrap;
}

/* Mobile Responsive Styles */
/* Desktop: make the two columns end level. Bootstrap already stretches the
   columns themselves, but the cards inside them keep their natural height, so
   the shorter column used to stop short of the preview. The equipment card (and
   the item list inside it) absorbs the difference, which also means a taller
   item list on roomier screens. */
@media (min-width: 768px) {
  #job-selection {
    display: flex;
    flex-direction: column;
  }

  #job-selection > .card:last-child {
    flex: 1 1 auto;
    min-height: 0;
  }

  #job-selection > .card:last-child > .card-body,
  #job-selection .tab-content,
  #job-selection .tab-content > .tab-pane.active {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
  }

  #job-selection .items-container {
    /* basis 0, not auto: with `auto` the list is sized by its ~800 items and the
       column grows enormous. At 0 it takes only the leftover space, so the
       column ends level with the preview. */
    flex: 1 1 0;
    height: auto;
    min-height: 250px;
  }
}

@media (max-width: 767px) {
  /* Mobile: the character must stay visible while the player browses items.
     The column order is flipped (preview first, see order-1/order-md-2), and the
     preview is pinned as a compact panel at the top of the scroll container so
     tapping an item in the list below shows the change immediately. The panel
     scrolls internally, so hair/colors are still reachable inside it. */
  #character-preview {
    position: sticky;
    top: 0;
    align-self: flex-start;
    z-index: 30;
  }

  /* No inner scroller here on purpose: a scrollable panel inside a scrollable
     page gives two scrollbars with nothing to indicate either, which reads as
     broken. The panel is instead kept short (compact sprite, single-row hair
     strip) so the whole thing fits and only the page scrolls. */
  #character-preview > .card {
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
  }

  .row {
    margin-right: 0;
    margin-left: 0;
  }
  
  .col-md-7, .col-md-5 {
    padding-right: 5px;
    padding-left: 5px;
  }
  
  .card-title {
    font-size: 1rem;
  }
  
  .items-container {
    height: 190px;
  }

  /* The hair grid is the tallest control in the preview panel. Laying it out as a
     single horizontally-scrolling row keeps the panel short enough to stay pinned
     on mobile without needing a second, hidden scrollbar inside it. */
  .hair-style-container.hair-strip {
    flex-wrap: nowrap;
    justify-content: flex-start;
    max-height: none;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scroll-snap-type: x proximity;
    scrollbar-width: thin;
  }
  .hair-style-container.hair-strip :deep(.ul-head-list) {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .hair-style-container.hair-strip :deep(li) {
    flex: 0 0 auto;
    scroll-snap-align: start;
  }
  /* A visible affordance that the strip scrolls (the user shouldn't have to guess). */
  .hair-style-container.hair-strip::-webkit-scrollbar {
    height: 6px;
  }
  .hair-style-container.hair-strip::-webkit-scrollbar-thumb {
    background: #c7ccd1;
    border-radius: 3px;
  }
  .hair-style-container.hair-strip::-webkit-scrollbar-track {
    background: #f1f3f5;
    border-radius: 3px;
  }

  /* Keep the pinned preview compact: colours scroll sideways like the hair strip
     instead of wrapping onto three rows. */
  .hair-color-strip {
    flex-wrap: nowrap !important;
    justify-content: flex-start !important;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .hair-color-strip :deep(.ul-hair-color) {
    flex-wrap: nowrap;
  }
  .hair-color-strip :deep(li) {
    flex: 0 0 auto;
  }

  .gender-controls {
    margin-bottom: 0.25rem !important;
  }
  
  .server-filter-container {
    flex-direction: column;
    align-items: flex-start;
    padding: 0.25rem;
    font-size: 0.8rem;
    width: 100%;
  }
  
  .form-check-label.me-1 {
    font-size: 0.75rem;
  }
  
  .nav-tabs .nav-link {
    padding: 0.25rem 0.4rem;
    font-size: 0.75rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 80px;
  }
  
  .btn-tab-item {
    width: 110px;
    min-height: 65px;
    margin-left: 2px;
    margin-right: 2px;
  }
  
  .character-container {
    height: 140px;
    min-height: 0;
    padding: 0;
    align-items: flex-end;
    overflow: hidden;
  }
  
  .action-buttons {
    flex-wrap: wrap;
    gap: 5px;
  }
  
  .action-buttons .btn {
    font-size: 0.7rem;
    padding: 0.2rem 0.4rem;
  }
}
</style>
